import { render } from "./SNavBar.vue?vue&type=template&id=148dcc7a"
import script from "./SNavBar.vue?vue&type=script&lang=js"
export * from "./SNavBar.vue?vue&type=script&lang=js"

import "./SNavBar.vue?vue&type=style&index=0&id=148dcc7a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__